// Donkere modus. De serverinstelling bepaalt het startthema, de keuze van de
// gebruiker wordt lokaal bewaard en in de <head> al toegepast (geen flits).
const STORAGE_KEY = 'theme';

const syncToggles = (theme) => {
    document.querySelectorAll('[data-ds-theme-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
};

document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ds-theme-toggle]');

    if (!toggle) {
        return;
    }

    event.preventDefault();

    const theme = document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'light' : 'dark';

    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
    syncToggles(theme);
});

document.addEventListener('DOMContentLoaded', () => {
    syncToggles(document.documentElement.getAttribute('data-bs-theme'));
});
